<div *ngxPermissionsOnly="'chat.list'"
     class="full-height layout-row layout-align-start-center">
  <bringoz-icon appBringozIdGenerator="serviceChatButton"
                iconName="chat"
                (click)="onClick($event)"></bringoz-icon>
</div>
